var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M18,0 C27.9411255,-1.82615513e-15 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 1.21743675e-15,27.9411255 0,18 C-1.21743675e-15,8.0588745 8.0588745,1.82615513e-15 18,0 Z M19.3034483,9 L16.6965517,9 L16.6965517,16.7688679 L9,16.7688679 L9,19.2735849 L16.6965517,19.2735849 L16.6965517,27 L19.3034483,27 L19.3034483,19.2735849 L27,19.2735849 L27,16.7688679 L19.3034483,16.7688679 L19.3034483,9 Z"})));
}

Plus.defaultProps = {"width":"36px","height":"36px","viewBox":"0 0 36 36","version":"1.1"};

module.exports = Plus;

Plus.default = Plus;
